"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numeralLocaleConfigFr = void 0;
exports.numeralLocaleConfigFr = {
    delimiters: {
        thousands: ' ',
        decimal: ',',
    },
    abbreviations: {
        thousand: 'k',
        million: 'm',
        billion: 'b',
        trillion: 't',
    },
    ordinal: (num) => {
        return num === 1 ? 'er' : 'e';
    },
    currency: {
        symbol: '€',
    },
};
